import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface PeaksProgressDetailsResponse {
  fast_phonics_progress_details: {
    summary: SummaryData
    students: StudentData[]
  }
}

interface SummaryData {
  lessons: { lessons_completed: number }
  book_quizzes: { books_read: number }
  lesson_quizzes: { student_average: number }
  sound_gems: { sound_gems_earned: number }
  word_gems: { word_gems_earned: number }
}

interface StudentData {
  student_id: number
  books_read: {
    book_code: string
    book_name: string
  }[]
  lesson_data: {
    lesson: number
    highest_score: number
    average_score: number
    lesson_quizzes_attempted: number
    quiz_scores: number[]
  }[]
}

export interface PeaksProgressDetailsData {
  summary: SummaryData
  students: StudentData[]
}

export async function peaksProgressDetails(
  this: StudentEventsService,
  product: LegacyProductFp,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<PeaksProgressDetailsData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('progress_details', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<PeaksProgressDetailsResponse>(url, query)
  if (!data) return null

  const { fast_phonics_progress_details } = data
  if (fast_phonics_progress_details.students.length === 0) return null

  return fast_phonics_progress_details
}
